import { ABP, eLayoutType } from '@abp/ng.core';

export const ROTA_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/rotas',
    iconClass: 'fas fa-route',
    name: '::Menu:Rotas',
    order: 1,
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Rotas',
    breadcrumbText: '::Rotas',
  },
];
